export default __webpack_public_path__ + "static/icon-16-2-8270f11643fb6022f6f6170acdaf751c.png";